import repository from '@/repositories/Repository'

const resource = '/item_category_levels'

export default {
  get(company) {
    return repository.bizoo.get(`${resource}/${company}`).then(r => r.data)
  },
}
